import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const modalWrapperStyle: StyleRulesCallback = () => ({
  root: {},
});

export default modalWrapperStyle;
